module.exports = __webpack_public_path__ + "static/media/app-name-img.7eb44a4a.svg";